import { render, staticRenderFns } from "./CloseAmortization.vue?vue&type=template&id=460220bb&"
import script from "./CloseAmortization.vue?vue&type=script&lang=ts&"
export * from "./CloseAmortization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('460220bb')) {
      api.createRecord('460220bb', component.options)
    } else {
      api.reload('460220bb', component.options)
    }
    module.hot.accept("./CloseAmortization.vue?vue&type=template&id=460220bb&", function () {
      api.rerender('460220bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-payables/amortization/CloseAmortization.vue"
export default component.exports